import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface customerDetailsStateType {
  filters: {
    status: string;
    eventType: string[];
    chef: string;
    bookingStatus: string;
    requirementType: string[];
  };
  offset: number;
}

const FILTERS_MODEL = {
  status: '',
  eventType: [],
  chef: '',
  bookingStatus: '',
  requirementType: [],
};

const initialState: customerDetailsStateType = {
  filters: FILTERS_MODEL,
  offset: 0,
};

const customerDetailsSlice = createSlice({
  name: 'customerDetails',
  initialState,
  reducers: {
    setFilters(
      state,
      action: PayloadAction<{ filters: customerDetailsStateType['filters'] }>,
    ) {
      return { ...state, filters: action.payload.filters };
    },
    setOffset(state, action: PayloadAction<{ offset: number }>) {
      return { ...state, offset: action.payload.offset };
    },
    clearFilters(state) {
      return { ...state, filters: FILTERS_MODEL };
    },
  },
});

export const { setFilters, setOffset, clearFilters } =
  customerDetailsSlice.actions;
export default customerDetailsSlice.reducer;
